const WRITE_REVIEW_PARAM = 'write_review';
const OPEN_AFTER_LOGIN_KEY = 'indigoOpenWriteReview';

function normalizeForMatch(str) {
  const lower = (str || '').toString().toLowerCase();

  try {
    return lower.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  } catch (err) {
    return lower;
  }
}

const EMPTY_STATE_COPY_RE = /(be the first|write a review|write review|soyez le premier|soyez la premiere|soyez les premiers|soyez les premieres|ecrire un avis|rediger un avis|donner un avis)/i;

function tightenScope(scopeEl, btn) {
  if (!scopeEl || !btn) return scopeEl;

  try {
    if (scopeEl.classList && scopeEl.classList.contains('product-yotpo')) {
      const inner = scopeEl.querySelector('.product-yotpo__contents') || scopeEl.querySelector('.product-yotpo__contents-wrapper');
      if (inner && inner.contains(btn)) return inner;
    }
  } catch (err) { /* ignore */ }
  return scopeEl;
}

function getIsLoggedIn() {
  // Primary: read Liquid-authored flag on <body>
  try {
    const flag = document.body && document.body.getAttribute('data-customer-logged-in');
    if (flag === 'true') return true;
    if (flag === 'false') return false;
  } catch (err) { /* ignore */ }
  // Fallback: infer from account link when flag is unavailable
  try {
    const accountLink = document.querySelector('.header__icon--account');
    if (!accountLink) return false;
    const href = accountLink.getAttribute('href') || '';
    return href.indexOf('/account/login') === -1 && href.indexOf('/customer_authentication/login') === -1;
  } catch (e) {
    return false;
  }
}

function redirectToLoginForWriteReview() {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set(WRITE_REVIEW_PARAM, '1');
  const returnUrl = currentUrl.pathname + currentUrl.search;

  try { sessionStorage.setItem(OPEN_AFTER_LOGIN_KEY, '1'); } catch (err) {
    console.warn('Yotpo gate: sessionStorage unavailable', err);
  }

  const loginUrl = new URL('/customer_authentication/login', window.location.origin);
  loginUrl.searchParams.set('return_to', returnUrl);
  window.location.href = loginUrl.href;
}

function addGateClickHandler(el) {
  if (!el) return;
  if (el.dataset && el.dataset.yotpoGateBound === 'true') return;
  if (el.dataset) el.dataset.yotpoGateBound = 'true';

  el.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    redirectToLoginForWriteReview();
  }, { capture: true });
}

function isLikelyEmptyStateWriteReview(scopeEl) {
  if (!scopeEl) return false;

  // Prefer text-based detection so we don't rely on unstable Yotpo classnames.
  const text = normalizeForMatch(scopeEl.textContent || '');
  const hasEmptyCopy = EMPTY_STATE_COPY_RE.test(text);

  if (!hasEmptyCopy) return false;

  // Avoid gating areas that already contain rendered review items.
  const hasRenderedReviews = Boolean(
    scopeEl.querySelector('[data-review-id], [data-yotpo-review-id], .yotpo-review, .yotpo-review-card, .yotpo-review-wrapper'),
  );

  return !hasRenderedReviews;
}

function findEmptyStateGateContainer(btn) {
  const scope = tightenScope(((btn && btn.closest && btn.closest('.product-yotpo'))
    || (btn && btn.closest && btn.closest('.yotpo-widget-instance'))
    || (btn && btn.parentElement)
    || null), btn);

  if (!btn || !scope) return btn;

  let node = btn;
  let best = btn;

  for (let depth = 0; depth < 8 && node && node !== scope; depth += 1) {
    node = node.parentElement;
    if (!node) break;

    const id = node.id || '';
    const cls = (node.className || '').toString();
    const looksYotpo = /yotpo/i.test(id) || /yotpo/i.test(cls);
    const hasEmptyCopy = EMPTY_STATE_COPY_RE.test(normalizeForMatch(node.textContent || ''));

    if (hasEmptyCopy) best = node;
    if (looksYotpo && hasEmptyCopy) {
      best = node;
      break;
    }
  }

  // If we couldn't find a better wrapper (common when copy is localized), fall back to the
  // tightest known scope so clicks near the button are also gated.
  if (best && best.contains && best.contains(btn) && best !== btn) return best;
  return scope;
}

function waitForYotpoButton(callback) {
  let attempts = 0;
  const maxAttempts = 50;
  const interval = setInterval(() => {
    const btn = document.querySelector('#yotpo-main-widget-btn');
    if (btn) {
      clearInterval(interval);
      callback(btn);
    } else {
      attempts += 1;
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }
  }, 200);
}

function openWriteReview(btn) {
  try { btn.click(); } catch (err) { console.warn('Yotpo gate: failed to open write review', err); }
}

function initYotpoGate() {
  // Only run on pages where the Yotpo widget can exist
  if (!document.querySelector('.product-yotpo, .yotpo-widget-instance')) return;

  waitForYotpoButton((btn) => {
    if (!getIsLoggedIn()) {
      addGateClickHandler(btn);

      const widgetScope = (btn.closest && (btn.closest('.product-yotpo') || btn.closest('.yotpo-widget-instance')))
        || btn.parentElement;
      if (isLikelyEmptyStateWriteReview(widgetScope)) {
        const gateContainer = findEmptyStateGateContainer(btn);
        if (gateContainer && gateContainer !== btn) addGateClickHandler(gateContainer);
      }
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      let shouldOpen = urlParams.get(WRITE_REVIEW_PARAM) === '1';
      try {
        if (!shouldOpen && sessionStorage.getItem(OPEN_AFTER_LOGIN_KEY) === '1') {
          shouldOpen = true;
          sessionStorage.removeItem(OPEN_AFTER_LOGIN_KEY);
        }
      } catch (err) { console.warn('Yotpo gate: sessionStorage unavailable', err); }
      if (shouldOpen) {
        setTimeout(() => { openWriteReview(btn); }, 400);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initYotpoGate);
